export default class LanguageFilter {
  constructor (filterData) {
    this.id = filterData.id
    this.name = filterData.name
  }
}
